import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { TrendingUp, TrendingDown, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

export default function Insights() {
  const [ins, setIns] = useState([]);
  useEffect(() => { api.get("/insights/weekly").then(r => setIns(r.data.insights)); }, []);
  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="font-heading text-3xl font-bold mb-2">Weekly Signal</h1>
      <p className="text-[color:var(--text-secondary)] mb-8">Daily and weekly status of your money.</p>
      <div className="space-y-3">
        {ins.map((i, idx) => (
          <motion.div key={idx} initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: idx * 0.05 }}
            className={`glass-card p-5 flex items-start gap-4 border ${i.type === "warning" ? "border-[rgba(224,106,59,0.3)]" : i.type === "positive" ? "border-[rgba(42,157,143,0.3)]" : "border-[rgba(212,175,55,0.15)]"}`}>
            {i.type === "warning" ? <TrendingUp className="w-5 h-5 text-[color:var(--terracotta)]" />
              : i.type === "positive" ? <TrendingDown className="w-5 h-5 text-[color:var(--emerald)]" />
                : <Sparkles className="w-5 h-5 text-[color:var(--gold)]" />}
            <div className="text-sm leading-relaxed">{i.text}</div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
